import { createSlice } from "@reduxjs/toolkit";
import {
  fetchIncomeRecord,
  fetchIncomeAccountsBySearch,
} from "./incomeRecordThunk";

const initialState = {
  list: [],
  details: [],
  listWithDetails: [],
  loading: false,
  incomeAccounts: [],
  filters: {
    filterType: "All",
    recordType: "without details",
    incId: null,
    userId: null,
    fromDate: null,
    toDate: null,
  },
};

const incomeRecordSlice = createSlice({
  name: "incomeRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetList: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncomeRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIncomeRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list || [];
        state.details = action.payload.details || [];
        state.listWithDetails = action.payload.listWithDetails || [];
      })
      .addCase(fetchIncomeRecord.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchIncomeAccountsBySearch.fulfilled, (state, action) => {
        state.incomeAccounts = action.payload;
      });
  },
});

export const { setFilters } = incomeRecordSlice.actions;
export default incomeRecordSlice.reducer;
